import React from 'react';
/**
 * This is the route used for S3 Error document setting to avoid client-only routes from showing 404 page.
 */
export default function ClientRoutes() {
  return <div />;
}
